import PropTypes from "prop-types";
import React from "react";
import {
  View,
  ScrollView,
  TouchableOpacity,
  UIManager,
  Platform,
  Animated,
  ActivityIndicator,
} from "react-native";
import ENV from "app/utils/ENV";
import Text from "app/components/Text";
import apiActions from "app/utils/apiActions";
import valueActions from "app/utils/valueActions";
import colorHelpers from "app/utils/colorHelpers";
import valueHelpers from "app/utils/valueHelpers";
import chapterHelpers from "app/utils/chapterHelpers";
import {
  FontAwesome,
  Entypo,
  MaterialIcons,
  MaterialCommunityIcons,
} from "@expo/vector-icons";

import Hoverable from "app/components/Hoverable";

import { StyleContext } from "app/contexts/Style";

export default class Tooltip extends React.Component {
  static contextType = StyleContext;
  static defaultProps = {
    numberOfLines: 3, // Allow multiple lines by default
  };

  constructor(props) {
    super(props);
    this.state = {
      isHovered: false,
      anim: new Animated.Value(0),
    };
  }

  componentDidMount() {
    Animated.spring(this.state.anim, {
      toValue: 1,
      bounciness: 4, // default 8
      speed: 40, // default 12
      useNativeDriver: !ENV.WEB,
    }).start(() => {});
  }

  render() {
    let {
      style,
      textStyle,
      rightAligned,
      rightInline,
      onPress,
      numberOfLines,
    } = this.props;

    let { isHovered, anim } = this.state;

    let buttonStyle = {};
    if (!!onPress) {
      buttonStyle = {
        textDecorationLine: "underline",
        opacity: isHovered ? 1 : 0.7,
      };
    }

    let animScale = anim.interpolate({
      inputRange: [0, 1],
      outputRange: [0, 1],
    });

    return (
      <Hoverable
        onHoverIn={() => this.setState({ isHovered: true })}
        onHoverOut={() => this.setState({ isHovered: false })}
      >
        <Animated.View
          style={[
            this.styles().wrapper,
            !!onPress && this.styles().pressableWrapper,
            rightAligned && this.styles().rightAligned,
            rightInline && this.styles().rightInline,
            this.props.floatingRight && this.styles().floatingRight,
            this.props.floatingLeft && this.styles().floatingLeft,
            this.props.bottomAligned && { top: "100%" },
            style,
            { transform: [{ scale: animScale }] },
          ]}
          pointerEvents={!!onPress ? undefined : "none"}
        >
          <TouchableOpacity disabled={!onPress} onPress={onPress}>
            <Text
              style={[this.styles().text, buttonStyle, textStyle]}
              numberOfLines={numberOfLines}
              ellipsizeMode="tail"
            >
              {this.props.children}
            </Text>
          </TouchableOpacity>
        </Animated.View>
      </Hoverable>
    );
  }

  styles = () => ({
    wrapper: {
      position: "absolute",
      // alignSelf: 'center',
      left: "0",
      top: "150%",
      backgroundColor: this.context.colors.trim,
      padding: this.context.sizes.small,
      paddingBottom: this.context.sizes.small * 1.6,
      borderRadius: this.context.sizes.tiny,
      zIndex: 9999,
      maxWidth: this.props.style?.width || 400,
      minWidth: 100,
      whiteSpace: "normal", // Allow text wrapping on web
    },
    rightAligned: {
      left: undefined,
      right: 0,
    },
    pressableWrapper: {
      // top: "99%",
      // left: "50%",
      // paddingHorizontal: this.context.sizes.base,
    },
    rightInline: {
      left: "100%",
      right: undefined,
      top: "40%",
    },
    floatingRight: {
      left: "110%",
      right: undefined,
      top: 0,
    },
    floatingLeft: {
      left: undefined,
      right: "110%",
      top: 0,
    },
    text: {
      // color: this.context.colors.empty,
      // textAlign: "justify",
      flexWrap: "wrap", // Allow text to wrap
    },
  });
}
